import { Link } from "react-router-dom";
import {
  IconButton,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Aish5XLogo } from "../branding/Aish5XLogo";

type Props = {
  showNavButton?: boolean; // 左側ハンバーガー（サイドバー用）
  onOpenNav?: () => void;  // 左側ハンバーガー押下時
};

const Header: React.FC<Props> = ({ showNavButton = false, onOpenNav }) => {

  return (
    <header className="fixed top-0 left-0 w-full z-[999] h-14 bg-white shadow flex items-center justify-between px-2">
      {/* 左側：ナビ用ハンバーガー + ロゴ */}
      <div className="flex items-center">
        {showNavButton && (
          <IconButton onClick={onOpenNav} aria-label="open navigation">
            <MenuIcon />
          </IconButton>
        )}

        <Link to="/">
          <Box
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              px: 1,
            }}
          >
            <Aish5XLogo height={32} />
          </Box>
        </Link>
      </div>

      {/* 右側：既存メニュー */}
      <div className="flex items-center gap-4">
        <Link to="/signup" className="text-sm hover:underline">
          新規登録
        </Link>
        <Link to="/login" className="text-sm hover:underline">
          ログイン
        </Link>
      </div>
    </header>
  );
};

export default Header;